import { render } from "./AdminDocumentVault.vue?vue&type=template&id=39f63f7a"
import script from "./AdminDocumentVault.vue?vue&type=script&lang=js"
export * from "./AdminDocumentVault.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__